module.exports = __webpack_public_path__ + "static/media/rabbitFlag.1efa2660.png";